import { render, staticRenderFns } from "./demo-form.vue?vue&type=template&id=ef9a510a&scoped=true&"
import script from "./demo-form.vue?vue&type=script&lang=js&"
export * from "./demo-form.vue?vue&type=script&lang=js&"
import style0 from "./demo-form.vue?vue&type=style&index=0&id=ef9a510a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9a510a",
  null
  
)

export default component.exports